import React from 'react';

export default function SectionTitle({ eyebrow, title, children }) {
  return (
    <div className="max-w-2xl">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#3fc0fa]">{eyebrow}</p>
      <h2 className="mt-4 text-3xl font-black tracking-tight sm:text-5xl">{title}</h2>
      {children && <p className="mt-5 text-lg leading-relaxed text-slate-500">{children}</p>}
    </div>
  );
}